import { arrayOf, shape } from 'prop-types';
import devices from '#props/shipment/device';

export default {
  devices: arrayOf(shape(devices))
};
